import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { ChainsRouter } from './chains.router';
import { ChainsComponent } from './chains.component';
import { ChainsEditComponent } from './chains.edit.component';
import { ChainsCreateComponent } from './chains.create.component';
import { ChainService } from './chain.service';

/** @constant {angular.module} */
const chainsModule = angular
  .module('ec.opsCenter.chains', [])
  .config(ChainsRouter)
  .service('chainService', ChainService)
  .directive('appChains', downgradeComponent({ component: ChainsComponent }) as angular.IDirectiveFactory)
  .directive('appChainsCreate', downgradeComponent({ component: ChainsCreateComponent }) as angular.IDirectiveFactory)
  .directive('appChainsEdit', downgradeComponent({ component: ChainsEditComponent }) as angular.IDirectiveFactory).name;

export default chainsModule;



// WEBPACK FOOTER //
// ./src/app/chains/chains.module.ajs.ts